import { render } from "./DepositoView.vue?vue&type=template&id=4918c41a"
import script from "./DepositoView.vue?vue&type=script&lang=js"
export * from "./DepositoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__